import { createUseStyles } from '../../theme/theming';
const useSectionStyles = createUseStyles((theme) => {
  return {
    section: {
      padding: `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
      background: theme?.colors?.background2,
      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      }
      // '& h2,& h3': {
      //   fontWeight: theme?.typography?.fontWeight?.medium,
      //   '& b,& strong': {
      //     fontWeight: theme?.typography?.fontWeight?.bold
      //   }
      // }
    },
    sectionContainer: {
      margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },
    centerData: {
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'center'

      // padding: `${theme?.spacing?.padding?.regular}px ${theme?.spacing?.padding?.medium}px 0px ${theme?.spacing?.padding?.medium}px`
    },
    imageContainerDiv: {
      width: '50%',
      position: 'relative'
    },
    imageContainer: {
      position: 'relative',
      width: '100%',
      // height: "650px"
      paddingBottom: ({ isCustomWebsite }) => (isCustomWebsite ? '85%' : ''),

      '& img': {
        height: '520px',
        objectFit: 'cover'
      }
    },
    imageBorder: {
      // border: `2px solid ${theme?.palette?.primary?.light}`,
      borderRadius: theme?.shape?.borderRadius?.small,
      position: 'absolute',
      width: '100%',
      height: '100%',
      bottom: '40px',
      right: '40px',
      zIndex: '1'
    },
    sideBannerImage: {
      width: '100%',
      position: 'relative',
      zIndex: '2',
      objectFit: 'cover'
    },
    textContainer: {
      marginLeft: '72px',
      textAlign: 'left',
      // margin: '0 auto',
      width: '50%'
    },
    subTitleHeading: {
      marginBottom: '8px',
      fontSize: theme?.typography?.fontSize?.subHead,
      letterSpacing: '3px',
      color: theme?.colors?.font3,
      wordBreak: 'break-word'
    },
    heading: {
      margin: '0',
      fontSize: theme?.typography?.fontSize?.h1,
      color: theme?.colors?.font3,
      wordBreak: ({ wordBreakValue }) => wordBreakValue || 'break-word',
      fontWeight: theme?.typography?.fontWeight?.bold,
      lineHeight: 'normal'
    },
    description: {
      marginTop: theme.spacing.margin.tiny,
      marginBottom: theme.spacing.margin.tiny,
      color: theme?.colors?.font3,
      lineHeight: '24px',
      wordBreak: 'break-word'
    },

    '@media screen and (max-width: 767px)': {
      section: {
        padding: `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
      },
      centerData: {
        flexDirection: 'column',
        width: '100%'
        // padding: `${theme?.spacing?.padding?.medium}px ${theme?.spacing?.padding?.regular}px`
      },
      imageContainer: {
        height: 'unset !important',
        '& img': {
          height: 'unset !important',
          objectFit: 'cover'
        }
      },
      imageContainerDiv: {
        width: '100%'
      },
      imageBorder: {
        display: 'none'
      },
      sideBannerImage: {
        width: '100%',
        height: 'unset !important'
      },
      textContainer: {
        padding: `${theme?.spacing?.padding?.regular}px 0px`,
        width: 'unset',
        margin: '0px',
        textAlign: 'center'
      },
      heading: {
        fontSize: `${theme?.typography?.fontSize?.h2}px`
      },
      subTitleHeading: {
        letterSpacing: '3px',
        lineHeight: '17px'
      },
      description: {
        margin: '16px 0'
      }
    }
  };
});

export default useSectionStyles;
